module.exports = __webpack_public_path__ + "img/deliveryGreen.e8be2a10.svg";